import type { ReactNode } from 'react'
import { useMemo } from 'react'

import { getRandomBackground } from '@/lib/backgroundImages'

interface CenteredFullScreenLayoutProps {
  children: ReactNode
  constrast?: boolean
}

export default function CenteredFullScreenLayout({ children, constrast }: CenteredFullScreenLayoutProps) {
  const background = useMemo(() => getRandomBackground(), [])

  return (
    <div
      className="h-screen w-screen bg-background font-sans antialiased flex items-center justify-center safe-area-padding bg-cover bg-center bg-no-repeat bg-fixed"
      style={{ backgroundImage: `url(${background})` }}
    >
      {constrast && (
        <div className="absolute inset-0 bg-background/80 dark:bg-background/90"></div>
      )}

      <div className="relative flex justify-center items-center z-10 w-full max-w-md px-4">
        {children}
      </div>
    </div>
  )
}
